import axios from 'axios';

const apiClient = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export const getBackups = () => {
    return apiClient.get('/backups/list');
};

export const createBackup = (backupName) => {
    return apiClient.post('/backups/create', { name: backupName });
};

export const restoreBackup = (fileName) => {
    return apiClient.post('/backups/restore', { filename: fileName });
};

export const deleteBackup = (fileName) => {
    return apiClient.delete(`/backups/${encodeURIComponent(fileName)}`);
};

export const getBackupConfig = () => {
    return apiClient.get('/backups/config');
};

export const updateBackupConfig = (config) => {
    return apiClient.put('/backups/config', config);
};
